import React, { useEffect } from 'react';
import { useSnackbar, VariantType } from 'notistack';
import TranslationHelper from '../helpers/TranslationHelper';

const ExternalSnackbar: React.FC = () => {
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (event.data?.type === 'SHOW_SNACKBAR' && event.data.message) {
                enqueueSnackbar(
                    TranslationHelper.translate(
                        event.data.message,
                        event.data.context || 'wx'
                    ),
                    {
                        variant:
                            (event.data.variant as VariantType) || 'default',
                    }
                );
            }
        };

        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [enqueueSnackbar]);

    return null;
};

export default ExternalSnackbar;
